export default __webpack_public_path__ + "static/media/pilot.a4f96354.png";